import React, { useEffect, useRef, useState } from "react";
// import "./css/campaignsViewMore.css";
import "./css/GoogleAnalyticsMetricsViewMore.css"
import { Line } from "react-chartjs-2";
import { getIconSrc } from "../../../helpers/getImgSrc";
import { Notifications } from "../../../components/Notifications";
import DropdownFilter from "../../../partials/filter/DropdownFilter";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import DateRangePicker from "../../../partials/date-range-picker/DateRangePicker";
import gsap from "gsap";
import { handleApi } from "../../../utils/authentication";
import { toast } from "react-toastify";
import LoadingSpinner from "../../../components/client/LoadingSpinner";
// import { format, parseISO, getISOWeek } from "date-fns";
import { parseISO, format, startOfISOWeek, getISOWeek } from "date-fns";

const SingleLineChart = ({ data, lineColor }) => {
  const options = {
    scales: {
      x: { display: false },
      y: { display: false },
    },
    plugins: {
      legend: { display: false },
    },
    elements: {
      point: { radius: 0 },
      line: { borderColor: lineColor },
    },
  };

  return <Line data={data} options={options} />;
};

const GoogleAnalyticsViewMore = () => {

  const campaigns_view_more_ref = useRef()

  const [selectedDateRange, setSelectedDateRange] = useState({
    label: "30 Days",
    value: "30"
  })
  const [customRange, setCustomRange] = useState({
    startDate: null,
    endDate: null
  })

  const [showDateRangePicker, setShowDateRangePicker] = useState(false);
  const [isLoading, setIsLoading] = useState(true)
  const [websiteMetricsData, setWebsiteMetricsData] = useState()
  const [websiteMetricsByCountry, setWebsiteMetricsByCountry] = useState([])
  const [graph_data, setGraphData] = useState([])
  const [sessionsMetricsData, setSessionsMetricsData] = useState([])
  const [viewsMetricsData, setViewsMetricsData] = useState([])
  const [tabsMetricsList, setTabsMetricsList] = useState([
    { label: "Active Users", value: "activeUsers" },
    { label: "Average Revenue Per User", value: "averageRevenuePerUser" },
    { label: "Engaged Sessions", value: "engagedSessions" },
    { label: "Engagement Rate", value: "engagementRate" },
    { label: "Event Count", value: "eventCount" },
    { label: "Key Events", value: "keyEvents" },
    { label: "New Users", value: "newUsers" },
    { label: "Sessions", value: "sessions" },
    { label: "Total Users", value: "totalUsers" }
  ])
  const [selectedTab, setSelectedTab] = useState({ label: "Active Users", value: "activeUsers" })
  const navigate = useNavigate()


  const [searchParams] = useSearchParams();

  const property_id = searchParams.get("property_id");
  const website_url = searchParams.get("website_url");
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]

  const data = {
    // labels: graph_data.map((item) => {
    //   let date = item?.month.split('-')
    //   console.log(months[parseInt(date[1]) - 1])
    //   return `${date[0] + "-" + months[parseInt(date[1]) - 1]}`
    // }),
    labels:graph_data?.labels,
    datasets: [
      {
        label: selectedTab?.label,
        // data: graph_data.map((item) => item.avgValue),
        data:graph_data?.dataset,
        fill: false,
        backgroundColor: "#D3A4FF",
        borderColor: "#1a73e8",
        borderWidth: 1,
        pointStyle: "rect",
        pointRadius: 5,
      },
      // {
      //   label: "Comments",
      //   data: [4, 39, 60, 7, 46],
      //   fill: false,
      //   backgroundColor: "#FFB1E0",
      //   borderColor: "#FFB1E0",
      //   borderWidth: 1,
      //   pointStyle: "rect",
      //   pointRadius: 5,
      // },
      // {
      //   label: "Shares",
      //   data: [35, 29, 0, 1, 36],
      //   fill: false,
      //   backgroundColor: "#95F3FA",
      //   borderColor: "#95F3FA",
      //   borderWidth: 1,
      //   pointStyle: "rect",
      //   pointRadius: 5,
      // },
      // {
      //   label: "Post Link Clicks",
      //   data: [25, 9, 40, 51, 26],
      //   fill: false,
      //   backgroundColor: "#FFE58A",
      //   borderColor: "#FFE58A",
      //   borderWidth: 1,
      //   pointStyle: "rect",
      //   pointRadius: 5,
      // },
      // {
      //   label: "Other Post Clicks",
      //   data: [15, 9, 30, 41, 16, 5, 0],
      //   fill: false,
      //   backgroundColor: "#8AABFF",
      //   borderColor: "#8AABFF",
      //   borderWidth: 1,
      //   pointStyle: "rect",
      //   pointRadius: 5,
      // },
    ],
  };

  const options = {
    scales: {
      y: {
        display: true,
        ticks: {
          display: true,
          stepSize: 15, // Set y-axis ticks with a 50 points gap
        },
        grid: {
          drawBorder: false,

          borderDash: [5, 5], // Ensure y-axis grid line is dashed
        },
      },
      x: {
        display: true,
      },
    },
    plugins: {
      legend: {
        position: "bottom",
        align: "start",
        labels: {
          boxWidth: 30,
          boxHeight: 10,
          padding: 20,
          usePointStyle: true,
          pointStyle: "rectRounded",
          color: "#1a73e8", // Set legend text color
        },
      },
      tooltip: {
        mode: "index", // Show tooltip for the entire column
        intersect: false,
      },
    },
    layout: {
      padding: {
        top: 20,
      },
    },
  };

  const reactionsData = {
    labels: ["January", "February", "March", "April"],
    datasets: [
      {
        data: [0, 59, 10, 81],
        fill: false,
        backgroundColor: "#D3A4FF",
        borderColor: "#D3A4FF",
        borderWidth: 1,
        pointStyle: "rect",
        pointRadius: 5,
      }
    ],
  };
  const leadsData = {
    labels: ["January", "February", "March", "April"],
    datasets: [
      {
        data: [0, 9, 10, 81],
        fill: false,
        backgroundColor: "#D3A4FF",
        borderColor: "#D3A4FF",
        borderWidth: 1,
        pointStyle: "rect",
        pointRadius: 5,
      }
    ],
  };
  const clicksData = {
    labels: ["January", "February", "March", "April"],
    datasets: [
      {
        data: [0, 1, 6, 0],
        fill: false,
        backgroundColor: "#D3A4FF",
        borderColor: "#D3A4FF",
        borderWidth: 1,
        pointStyle: "rect",
        pointRadius: 5,
      }
    ],
  };
  const applicationsData = {
    labels: ["January", "February", "March", "April"],
    datasets: [
      {
        data: [0, 5, 60, 51, 0],
        fill: false,
        backgroundColor: "#D3A4FF",
        borderColor: "#D3A4FF",
        borderWidth: 1,
        pointStyle: "rect",
        pointRadius: 5,
      }
    ],
  };


  const handleDateRangeSelect = (selectedOption) => {
    if (selectedOption.value == "Custom Range") {
      setShowDateRangePicker(true)

    } else {
      setSelectedDateRange(selectedOption)
    }
  };
  useEffect(() => {
    if (customRange?.startDate || customRange?.endDate) {
      setSelectedDateRange({
        value: "Custom Range",
        label: "Custom Range"
      })
    }
  }, [customRange?.startDate, customRange?.endDate]);


  useEffect(() => {
    gsap.from(campaigns_view_more_ref.current, {
      y: 500,
      duration: 1,
      // opacity: 0,
      ease: "easeIn",
      onComplete: () => {
        if (campaigns_view_more_ref.current && campaigns_view_more_ref.current.style.transform)
          campaigns_view_more_ref.current.style.transform = "";
      },
    });

  }, []);

  // Step 1: Group data by month and year
  const processData = (data, metric) => {
    const monthlyData = {};

    data.forEach((item) => {
      const date = new Date(item.date);
      const yearMonth = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`; // "YYYY-MM"

      if (!monthlyData[yearMonth]) {
        monthlyData[yearMonth] = { total: 0, count: 0 };
      }

      monthlyData[yearMonth].total += item[metric]; // Sum the selected metric
      monthlyData[yearMonth].count += 1;
    });

    // Convert grouped data into an array
    return Object.entries(monthlyData)
      .map(([month, values]) => ({
        month,
        avgValue: values.total / values.count, // Average value per month
      }))
      .sort((a, b) => new Date(a.month) - new Date(b.month)); // Sort by date
  };

//   const getWeeklyMetricsForChart = (data, selectedMetric) => {
//     const weeklyData = data.reduce((acc, entry) => {
//         const date = parseISO(entry.date);
//         const weekLabel = `${format(date, "yyyy")}-W${getISOWeek(date)}`;

//         if (!acc[weekLabel]) {
//             acc[weekLabel] = { week: weekLabel, count: 0, sum: 0 };
//         }

//         acc[weekLabel].count += 1;
//         acc[weekLabel].sum += entry[selectedMetric];

//         return acc;
//     }, {});

//     // Convert object to sorted array for Chart.js
//     const sortedData = Object.values(weeklyData).sort((a, b) => a.week.localeCompare(b.week));

//     return {
//         labels: sortedData.map(d => d.week), // X-axis: Weeks
//         dataset: sortedData.map(d => d.sum ), // Y-axis: Average Metric Value
//     };
// };
const getWeeklyMetricsForChart = (data, selectedMetric) => {
  const weeklyData = data.reduce((acc, entry) => {
      const date = parseISO(entry.date);
      const weekStart = startOfISOWeek(date); // Get the start date of the week
      const weekLabel = format(weekStart, "yyyy-MM-dd"); // Format as YYYY-MM-DD

      if (!acc[weekLabel]) {
          acc[weekLabel] = { week: weekLabel, count: 0, sum: 0 };
      }

      acc[weekLabel].count += 1;
      acc[weekLabel].sum += entry[selectedMetric];

      return acc;
  }, {});

  // Convert object to sorted array for Chart.js
  const sortedData = Object.values(weeklyData).sort((a, b) => a.week.localeCompare(b.week));

  return {
      labels: sortedData.map(d => d.week), // X-axis: Week Start Dates
      dataset: sortedData.map(d => d.sum), // Y-axis: Total Metric Sum
  };
};

  //getting campaign details
  const getWebsiteMetrics = async () => {
    try {
      setIsLoading(true);
      let method = "POST";
      let headers = {};
      let formData = new FormData();
      formData.append("property_id", property_id);
      formData.append("website_url", website_url);
      
      if(selectedDateRange?.value)
      {
        formData.append("days", selectedDateRange?.value);
      }
      if(selectedDateRange?.value==="Custom Range")
        {
       
         if(customRange?.startDate)
         {
          const startDate = customRange?.startDate; // MM/DD/YYYY format
          const [ startday,startmonth, startyear] = startDate.split("/");
           const formattedStartDate = `${startyear}-${startmonth.padStart(2, "0")}-${startday.padStart(2, "0")}`;
           formData.append('start_date',formattedStartDate)

         }
         if(customRange?.endDate)
          {
           const endDate = customRange?.endDate; // MM/DD/YYYY format
           const [ endday,endmonth, endyear] = endDate.split("/");
          const formattedEndDate = `${endyear}-${endmonth.padStart(2, "0")}-${endday.padStart(2, "0")}`;
          formData.append('end_date',formattedEndDate)
 
          }
  
        }
      

      let result = await handleApi("get_google_analytics_website_metrics", method, headers, formData);
      if (result?.success) {
        setWebsiteMetricsData(result?.data?.website_metrics)

        // if(Object.keys(result?.data?.country_website_metrics_response)?.length>0)
        //   setWebsiteMetricsByCountry(result?.data?.country_website_metrics_response)
        if (Object.keys(result?.data?.country_website_metrics_response)?.length > 0) {
          const sortedMetrics = Object.entries(result?.data?.country_website_metrics_response)
            .sort(([, a], [, b]) => b.activeUsers - a.activeUsers) // Sort by activeUsers (Descending)
            .slice(0, 10) // Take top 10 records
            .reduce((acc, [key, value]) => {
              acc[key] = value;
              return acc;
            }, {});

          setWebsiteMetricsByCountry(sortedMetrics);
         
          // let graph_data = processData(result?.data?.graph_website_metrics_response, selectedTab?.value)
          let graph_data =getWeeklyMetricsForChart(result?.data?.graph_website_metrics_response, selectedTab?.value)
          setGraphData(graph_data)
          setSessionsMetricsData(result?.data?.session_website_metrics_response)
          setViewsMetricsData(result?.data?.views_website_metrics_data)
        }

      } else {
        toast.error(
          result?.error?.error_message
            ? result?.error?.error_message
            : "Failed to get Website  details"
        );
      }
    } catch (e) {
      toast.error(e.message ? e.message : "Failed to get Website  details");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getWebsiteMetrics()
  }, [selectedTab,selectedDateRange]);



  return (
    <>
      {/* {isLoading ? <LoadingSpinner /> : */}
      <div ref={campaigns_view_more_ref}>
        <div className="campaigns-view-more-header">
          <div className="campaigns-view-more-header-top-section d-flex justify-content-between align-items-center flex-wrap">
            <div className="d-flex align-items-center gap-3 flex-wrap">
              <div
                style={{ cursor: "pointer" }}
                onClick={() => {
                  navigate("/client/track-google-analytics");
                }}
                className="d-flex align-items-center"
              >
                <img className="" src={getIconSrc("arrow", "svg")}></img>
              </div>
              <div>
                <span className="campaigns-view-more-page-title">
                  {websiteMetricsData?.display_name}
                </span>
                <span
                  className="ms-2 "
                  style={{
                    color: "gray",
                    fontSize: "14px",
                    fontFamily: "aeonik_medium",
                  }}
                >
                  {/* (August 21 App deadline Campaign) */}
                </span>
              </div>


            </div>
            <div className="d-flex align-items-center gap-3">
              <DropdownFilter
                styling={{ backgroundColor: "transparent" }}
                label={"Date"}
                onSelect={handleDateRangeSelect}
                options={[
                  { value: null, label: "All Time" },
                  { value: 30, label: "30 Days" },
                  { value: 90, label: "90 Days" },
                  { value: 180, label: "180 Days" },
                  { value: "Custom Range", label: "Custom Range" },
                ]}
                selectedOption={{
                  value: selectedDateRange.value,
                  label: selectedDateRange.label,
                }}
              />
              <Notifications />
              <div style={{ cursor: "pointer" }}>
                <img className="" src={getIconSrc("export", "svg")}></img>
              </div>
            </div>
          </div>
          <div className="campaigns-view-more-header-content row m-0 ">
            <div className="col-md-3 row m-0 d-flex align-items-center">
              <div className="col-md-5">
                <div className="header-content-label">Screen Page Views</div>
                <div className="header-content-value">{websiteMetricsData?.screen_page_views ?? 0}</div>
              </div>
              <div className="col-md-7">
                <SingleLineChart data={reactionsData} lineColor="#D3A4FF" />
              </div>
            </div>
            <div className="col-md-3 row m-0 d-flex align-items-center">
              <div className="col-md-5">
                <div className="header-content-label">Sessions</div>
                <div className="header-content-value">{websiteMetricsData?.sessions ?? 0}</div>

              </div>
              <div className="col-md-7">
                <SingleLineChart data={clicksData} lineColor="#FFB1E0" />
              </div>
            </div>
            <div className="col-md-3 row m-0 d-flex align-items-center">
              <div className="col-md-5">
                <div className="header-content-label">Active Users</div>
                <div className="header-content-value">{websiteMetricsData?.active_users ?? 0}</div>

              </div>
              <div className="col-md-7">
                <SingleLineChart data={leadsData} lineColor="#95F3FA" />
              </div>
            </div>
            <div className="col-md-3 row m-0 d-flex align-items-center">
              <div className="col-md-5">
                <div className="header-content-label">Total Users</div>
                <div className="header-content-value">{websiteMetricsData?.total_users ?? 0}</div>

              </div>
              <div className="col-md-7">
                <SingleLineChart data={applicationsData} lineColor="#FFE58A" />
              </div>
            </div>
          </div>
          <div className="campaigns-view-more-body">
            <div className="campaigns-view-more-card">
              <div className="campaigns-view-more-card-header d-flex justify-content-between flex-wrap gap-2">
                <div className="d-flex flex-column gap-2">
                  <div className="chart-label">Average Revenue Per User</div>
                  <div className="chart-value">{websiteMetricsData?.average_revenue_per_user ?? 0}</div>
                </div>
                <div className="d-flex flex-column gap-2">
                  <div className="chart-label">Bounce Rate</div>
                  <div className="chart-value">{websiteMetricsData?.bounce_rate ?? 0}</div>
                </div>
                <div className="d-flex flex-column gap-2">
                  <div className="chart-label">Total Revenue</div>
                  <div className="chart-value">{websiteMetricsData?.total_revenue ?? 0}</div>
                </div>
                <div className="d-flex flex-column gap-2">
                  <div className="chart-label">New Users</div>
                  <div className="chart-value">{websiteMetricsData?.new_users ?? 0}</div>
                </div>
                <div className="d-flex flex-column gap-2">
                  {/* <div className="chart-label">OTHER POST CLICKS</div>
              <div className="chart-value">75</div> */}
                  <div className="chart-label"></div>
                  <div className="chart-value"></div>
                </div>
              </div>
              <div className="campaigns-view-more-card-body">

                {/* graph data */}
                <div className="campaigns-view-more-card-body-table">
                  <div className="campaigns-view-more-card-body-table-container" >
                    <div className="d-flex gap-4 align-items-center graph_metrics_container flex-wrap ">
                      {tabsMetricsList?.map((tab) => {
                        return <div className="cursor-pointer graph_metrics_tab" onClick={() => {

                          setSelectedTab(tab)
                        }}>
                          <p className={selectedTab?.label == tab?.label ? 'active_graph_metrics_tab' : ''}>{tab?.label}</p>
                          <div className="active_border" style={{ opacity: selectedTab?.label == tab?.label ? '100%' : '0%' }}></div>
                        </div>
                      })}

                    </div>
                    <div style={{minHeight:'5rem',position:'relative'}}>
                       {isLoading && <LoadingSpinner />}
                      {!isLoading && <Line data={data} options={options} />}
                    </div>
          

                  </div>
                </div>

                {/* metrics data */}
                {/* <Line data={data} options={options} /> */}
                <div className="campaigns-view-more-card-body-table">
                  <div className="campaigns-view-more-card-body-table-container" >
                    <div className="table-heading">
                      <h1>Website Engagement Metrics by Country</h1>
                    </div>
                    <div className="heading-table-devider">

                    </div>
                    <div className="table-container">
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th scope="col">Country</th>
                            <th scope="col">Active Users</th>
                            <th scope="col">Engaged Sessions</th>
                            <th scope="col">Engagement rate</th>
                            <th scope="col">New Users</th>
                          </tr>
                        </thead>
                        <tbody>
                      
                       {isLoading &&  <div style={{minHeight:'5rem',position:'relative'}}> <LoadingSpinner /> </div>}
                       {!isLoading && Object.keys(websiteMetricsByCountry)?.length == 0 && <div style={{minHeight:'5rem',position:'relative'}}> 
                          <div className="d-flex justify-content-center align-items-center">
                          <p>No Data Available</p>
                          </div>
                          
                        
                        </div>}
                     
                       {!isLoading && Object.keys(websiteMetricsByCountry)?.length > 0 && Object.keys(websiteMetricsByCountry)?.map((country) => {

                            return <tr>
                              <td>{country}</td>
                              <td>{websiteMetricsByCountry[country]?.activeUsers}</td>
                              <td>{websiteMetricsByCountry[country]?.engagedSessions}</td>
                              <td>{websiteMetricsByCountry[country]?.engagementRate?.toFixed(2)}%</td>
                              <td>{websiteMetricsByCountry[country]?.newUsers}</td>

                            </tr>

                          })}

                        </tbody>

                      </table>

                    </div>

                  </div>

                </div>

                {/* sessions metrics data */}
                <div className="campaigns-view-more-card-body-table d-flex gap-5 ">
                  <div className="campaigns-view-more-card-body-table-container flex-grow-1" >
                    <div className="table-heading">
                      <h1>Website Sessions Metrics </h1>
                    </div>
                    <div className="heading-table-devider">

                    </div>
                    <div className="table-container">
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th scope="col">Name</th>
                            <th scope="col">Sessions</th>

                          </tr>
                        </thead>
                        <tbody>
                        {isLoading &&  <div style={{minHeight:'5rem',position:'relative'}}> <LoadingSpinner /> </div>}
                        {!isLoading &&  sessionsMetricsData?.length  == 0 && <div style={{minHeight:'5rem',position:'relative'}}> 
                          
                        <div className="d-flex justify-content-center align-items-center">
                          <p>No Data Available</p>
                          </div>
                        
                        </div>}
                          {!isLoading && sessionsMetricsData?.length > 0 && sessionsMetricsData?.map((sessionData) => {
                            return <tr>
                              <td>{sessionData?.name}</td>
                              <td>{sessionData?.sessions}</td>
                            </tr>
                          })}



                        </tbody>

                      </table>

                    </div>

                  </div>


                  <div className="campaigns-view-more-card-body-table-container flex-grow-1" >
                    <div className="table-heading">
                      <h1>Website Views Metrics </h1>
                    </div>
                    <div className="heading-table-devider">

                    </div>
                    <div className="table-container">
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th scope="col">Name</th>
                            <th scope="col">Views</th>

                          </tr>
                        </thead>
                        <tbody>
                  
                        
                        {isLoading &&  <div style={{minHeight:'5rem',position:'relative'}}> <LoadingSpinner /> </div>}
                        {!isLoading &&  viewsMetricsData?.length  == 0 && <div style={{minHeight:'5rem',position:'relative'}}> 
                          
                        <div className="d-flex justify-content-center align-items-center">
                          <p>No Data Available</p>
                          </div>
                        
                        </div>}
                          {!isLoading && viewsMetricsData?.length > 0 && viewsMetricsData?.map((views) => {
                            return <tr>
                              <td>{views?.pagePath}</td>
                              <td>{views?.screenPageViews}</td>
                            </tr>
                          })}


                        </tbody>

                      </table>

                    </div>

                  </div>



                </div>


              </div>
            </div>
          </div>
        </div>
        <DateRangePicker
          showDateRangePicker={showDateRangePicker}
          setShowDateRangePicker={setShowDateRangePicker}
          dateRange={customRange}
          setDateRange={setCustomRange}
        />
      </div>
      {/* } */}
    </>
  );
};

export default GoogleAnalyticsViewMore;
